import { useIsBlaze } from './useIsBlaze'
import { useCurrentWorkspace } from './useCurrentWorkspace'

export const useDocumentationFeatures = () => {
  const isBlaze = useIsBlaze()
  const isAlmanac = !isBlaze
  const workspace = useCurrentWorkspace()

  const isDocumentationEnabled = isAlmanac || !!workspace?.documentation_enabled

  return { isDocumentationEnabled }
}
